"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Principles() {
  const container = useRef<HTMLDivElement>(null);
  const principles = [{
    id: 1,
    label: "Excelência",
    title: "Limpeza de Tanques",
    body: "Os produtos TankJet® melhoram a eficácia da limpeza, reduzem os tempos de paragem e aumentam a segurança dos trabalhadores. Além disso, estes sistemas reduzem o consumo de água e de agentes de limpeza. Podemos ajudá-lo a selecionar a opção de produto adequada a partir da nossa vasta gama.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=g3e90z3mzmt",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=21xgnlcqqbmi-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.12.png?v=s2lmqxgf3gl-wvc-sizes",
    alt: "Componente de engenharia industrial com acabamento metálico polido"
  }, {
    id: 2,
    label: "Parceria",
    title: "Secagem e Sopro",
    body: "A secagem de garrafas e latas pode ser um desafio. As facas de ar WindJet® secam eficazmente todos os tipos de embalagens, reduzindo — ou mesmo eliminando — a utilização de ar comprimido.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=p6vaqtnn4nn",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=hqfgzo1xsdt-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.18.png?v=14y4vhpa55o-wvc-sizes",
    alt: "Equipamento de pulverização industrial em ambiente de fábrica"
  }, {
    id: 3,
    label: "Inovação",
    title: "Lubrificação de Correntes de Transportadores",
    body: "A tecnologia de pulverização eletrostática lubrifica eficazmente as correntes dos transportadores, eliminando a overspray, reduzindo a necessidade de limpeza e melhorando o ambiente de trabalho.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=umxnxhpeyx",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=dhjd6gshrrm-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-15.51.23.png?v=b0shrkwao79-wvc-sizes",
    alt: "Sistema de controlo de pulverização automatizado em operação"
  }];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".principle-eyebrow", {
        y: 16
      });
      gsap.to(".principle-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.set(".principle-heading", {
        y: 28
      });
      gsap.to(".principle-heading", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        delay: 0.1,
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.set(".principle-card", {
        y: 40
      });
      gsap.to(".principle-card", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".principles-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".principle-eyebrow", ".principle-heading", ".principle-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31279" id="bebidasintroduction" data-nav="dark" className="relative bg-background text-foreground overflow-hidden">
      <div ref={container} className="relative mx-auto max-w-[1360px] px-5 sm:px-8 lg:px-16 py-[clamp(96px,14vh,180px)]">
        <div className="relative mx-auto max-w-3xl text-center">
          <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[420px] w-[720px] max-w-full rounded-lg blur-3xl opacity-30" style={{
          background: "radial-gradient(circle at center, hsl(215 80% 20% / 0.55), transparent 70%)"
        }} />
          <div className="principle-eyebrow relative text-[0.72rem] font-medium uppercase tracking-[0.22em] text-muted-foreground" style={{
          opacity: 0
        }}>Os especialistas da Spraying Systems Co. têm ajudado as principais empresas de bebidas a aumentar a eficiência em operações de pulverização que vão desde o revestimento e lavagem de latas até ao enxaguamento e secagem de garrafas. Ajudá-lo-emos a fazer o mesmo — garantindo qualidade, segurança e produtividade.</div>
          <h2 className="principle-heading relative mt-6 font-default text-foreground" style={{
          opacity: 0,
          fontSize: "clamp(2.25rem, 5.2vw, 4.75rem)",
          lineHeight: 0.98,
          letterSpacing: "-0.03em",
          fontWeight: 450
        }}>Tecnologia de Pulverização para Bebidas</h2>
        </div>

        <div className="principles-grid mt-[clamp(64px,10vh,120px)] grid grid-cols-1 md:grid-cols-3 gap-6">
          {principles.map((p, i) => <article key={p.id} data-index={i} className="principle-card group relative flex flex-col rounded-2xl p-8 sm:p-10 min-h-[520px] transition-all duration-300 ease-out hover:-translate-y-1" style={{
          opacity: 0,
          background: "hsl(210 20% 98% / 0.8)",
          backdropFilter: "blur(28px) saturate(140%)",
          WebkitBackdropFilter: "blur(28px) saturate(140%)",
          border: "1px solid hsl(210 10% 85%)",
          boxShadow: "inset 0 1px 0 hsl(0 0% 100% / 0.5)"
        }} onMouseEnter={e => {
          e.currentTarget.style.borderColor = "hsl(215 90% 45% / 0.4)";
          e.currentTarget.style.boxShadow = "0 10px 30px -5px hsl(215 80% 20% / 0.1)";
        }} onMouseLeave={e => {
          e.currentTarget.style.borderColor = "hsl(210 10% 85%)";
          e.currentTarget.style.boxShadow = "inset 0 1px 0 hsl(0 0% 100% / 0.5)";
        }}>
              <div className="relative w-full overflow-hidden rounded-lg" style={{
            height: "240px",
            border: "1px solid hsl(210 10% 85%)"
          }}>
                <img src={p.image} data-wvc-srcset={p.srcset} data-wvc-sizes={p.sizes} alt={p.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
              background: "radial-gradient(circle at 50% 60%, hsl(215 80% 20% / 0.1), transparent 70%)"
            }} />
              </div>

              <div className="mt-8 text-[0.7rem] font-medium uppercase tracking-[0.22em] text-muted-foreground">
                {`0${p.id} — ${p.label}`}
              </div>

              <h3 className="mt-4 font-default text-foreground" style={{
            fontSize: "clamp(1.35rem, 1.8vw, 1.75rem)",
            lineHeight: 1.12,
            letterSpacing: "-0.02em",
            fontWeight: 500
          }}>
                {p.title}
              </h3>

              <p className="mt-5 text-muted-foreground" style={{
            fontSize: "clamp(0.98rem, 1vw, 1.05rem)",
            lineHeight: 1.6,
            fontWeight: 350
          }}>
                {p.body}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}